import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {RankingServiceProvider} from "../ranking-service/ranking-service";
import {PlayerServiceProvider} from "../../../core/services/player-service/player-service";

/*
  Generated class for the CampaignServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CampaignServiceProvider {
  playerCampaigns = [];

  constructor(public http: HttpClient, private playerService:PlayerServiceProvider ,
              private rankingService:RankingServiceProvider) {}

  load(){
    return new Promise((resolve, reject) => {
      Promise.all([this.playerService.getPlayer(),this.rankingService.getRankingDefinitions()])
        .then((response:any)=>{
          let player = response[0];
          let rankingsDefinition = response[1];
          this.playerCampaigns = [];
          let allPlayerCampaigns = null;

          if (player && player.params && player.params.campaignMember) {
            allPlayerCampaigns = player.params.campaignMember;
          }

          if (allPlayerCampaigns && allPlayerCampaigns.length > 0) {
            for (let i = allPlayerCampaigns.length - 1; i >= 0; i--) {
              for (let j = 0; j < rankingsDefinition.length; j++) {
                if (rankingsDefinition[j].params.campaign && allPlayerCampaigns[i] === rankingsDefinition[j].params.campaign) {
                  this.playerCampaigns.push(allPlayerCampaigns[i]);
                  break;
                }
              }
            }

            if (this.playerCampaigns.length >= 1) {
              let currentCampaign = this.getCurrentCampaign();

              if (currentCampaign && currentCampaign === 'null' || currentCampaign === null) {
                currentCampaign = this.playerCampaigns[0];
                this.setCurrentCampaign(currentCampaign);
              }
            }
          }
          resolve();
        }).catch(err=>{
          console.error(err);
          reject(err);
      })
    })
  }

  getRankingsDefinition(rankingsDefinition) {
    let currentCampaign = this.getCurrentCampaign();

    if (this.playerCampaigns.length > 1 && (currentCampaign && currentCampaign !== 'null' || currentCampaign !== null)) {
      let response = [];

      for (let j = 0; j < rankingsDefinition.length; j++) {
        if (rankingsDefinition[j].params.campaign && rankingsDefinition[j].params.campaign === currentCampaign) {
          response.push(rankingsDefinition[j]);
        }
      }

      return response;
    }
    else {
      return rankingsDefinition;
    }
  }
  getTargetsDefinition(targetsDefinitions) {
    let currentCampaign = this.getCurrentCampaign();

    if (this.playerCampaigns.length > 1 && (currentCampaign && currentCampaign !== 'null' || currentCampaign !== null)) {

      for (let task in targetsDefinitions) {
        if (!(targetsDefinitions[task].params.campaign && targetsDefinitions[task].params.campaign === currentCampaign)) {
          delete targetsDefinitions[task];
        }
      }

    }
    return targetsDefinitions;
  }
  getUserCampaigns() {
    return this.playerCampaigns;
  }
  resetPlayerCampaigns() {
    this.playerCampaigns = [];
    this.setCurrentCampaign(null);
  }
  setCurrentCampaign(campaign) {
    this.rankingService.setFilters(null);
    this.rankingService.setGroupFilters(null);
    window.localStorage.setItem('currentCampaign', campaign);
  }
  getCurrentCampaign() {
    return window.localStorage.getItem('currentCampaign') || null;
  }
}



// WEBPACK FOOTER //
// ./src/modules/ranking/services/campaign-service/campaign-service.ts